export const START_FETCH_SERVICE_PAGE_DATA = "START_FETCH_SERVICE_PAGE_DATA";
export const SUCCESS_FETCH_SERVICE_PAGE_DATA =
  "SUCCESS_FETCH_SERVICE_PAGE_DATA";
export const ERROR_FETCH_SERVICE_PAGE_DATA = "ERROR_FETCH_SERVICE_PAGE_DATA";
